import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const RECENT_ITEMS_KEY = '/rest/thread/list_recent';
export const getThreadsQueryKey = (params) => params
    ? QueryClientHelper.makeQueryKey('/rest/thread/list_ask_threads', params)
    : QueryClientHelper.makeQueryKey('/rest/thread/list_ask_threads');
export const getArticlesQueryKey = getThreadsQueryKey;
export const getPinnedThreadsQueryKey = (params) => params
    ? QueryClientHelper.makeQueryKey('/rest/thread/list_pinned_ask_threads', params)
    : QueryClientHelper.makeQueryKey('/rest/thread/list_pinned_ask_threads');
export const getPinnedItemsQueryKey = (params) => params
    ? QueryClientHelper.makeQueryKey('/rest/pins', params)
    : QueryClientHelper.makeQueryKey('/rest/pins');
export const getScheduledComputerTasksQueryKey = (params) => params
    ? QueryClientHelper.makeQueryKey('/rest/thread/list_scheduled_computer_tasks', params)
    : QueryClientHelper.makeQueryKey('/rest/thread/list_scheduled_computer_tasks');
export const getThreadByUUIDKey = (uuid, supportedBlockUseCases) => QueryClientHelper.makeQueryKey('/rest/thread/{entry_uuid_or_slug}', uuid, supportedBlockUseCases);
export const getThreadMembersQueryKey = (backendUUID) => QueryClientHelper.makeQueryKey('/rest/thread/{backend_uuid}/members', { backendUUID });
export const getThreadRequestAccessInfoQueryKey = (uuidOrSlug) => QueryClientHelper.makeQueryKey('/rest/thread/request-access-info/{entry_uuid_or_slug}', uuidOrSlug);
export const getComputerSideChatsQueryKey = (parentContextUuid) => QueryClientHelper.makeQueryKey('/rest/thread/computer_side_chats/{parent_context_uuid}', {
    parentContextUuid,
});
export const getComputerSideChatsQueryKeyPrefix = () => QueryClientHelper.makeQueryKey('/rest/thread/computer_side_chats/{parent_context_uuid}');
// versioned keys restore the account-scoped persisted cache while requests refresh it.
export const getSidebarV2InitialQueryKey = (viewer) => QueryClientHelper.makeQueryKey('graphql-sidebar-v2', 'initial-pages-with-teammates', ...(viewer ? [viewer] : []));
export const getSidebarV2ProjectThreadsQueryKey = (uuid) => QueryClientHelper.makeQueryKey('graphql-sidebar-v2', 'projectThreads', ...(uuid ? [uuid] : []));
export function getAffectedSidebarProjectThreadQueries({ projectUUIDs, entryUUIDs, contextUUIDs, }) {
    return {
        queryKey: getSidebarV2ProjectThreadsQueryKey(),
        predicate: ({ queryKey, state }) => {
            if (projectUUIDs?.includes(String(QueryClientHelper.unmakeQueryKey(queryKey)[2])))
                return true;
            const data = state.data;
            return (data?.items?.some((row) => Boolean(entryUUIDs?.includes(row.uuid) || contextUUIDs?.includes(row.context_uuid))) ?? false);
        },
    };
}
//# sourceMappingURL=threadKeys.js.map